var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1.73969C16.3625 2.04897 15.6896 2.24227 14.9812 2.35825C15.6896 1.89433 16.2563 1.15979 16.5042 0.270619C15.8313 0.695876 15.0875 1.00515 14.2729 1.19845C13.6354 0.463918 12.7146 0 11.7229 0C9.81042 0 8.25208 1.70103 8.25208 3.78866C8.25208 4.09794 8.2875 4.36856 8.35833 4.63918C5.48958 4.48454 2.90417 2.9768 1.16875 0.657216C0.885417 1.23711 0.708333 1.85567 0.708333 2.55155C0.708333 3.86598 1.31042 5.02577 2.26667 5.72165C1.7 5.68299 1.16875 5.52835 0.672917 5.25773V5.29639C0.672917 7.15206 1.87708 8.69845 3.47083 9.04639C3.1875 9.12371 2.86875 9.16237 2.55 9.16237C2.3375 9.16237 2.08958 9.12371 1.87708 9.08505C2.3375 10.5928 3.6125 11.7139 5.13542 11.7139C3.93125 12.7191 2.44375 13.3376 0.814583 13.3376C0.53125 13.3376 0.247917 13.3376 0 13.299C1.55833 14.3814 3.36458 15 5.34792 15C11.7583 15 15.2646 9.20103 15.2646 4.17526C15.2646 4.02062 15.2646 3.82732 15.2646 3.67268C15.9375 3.1701 16.5396 2.51289 17 1.73969Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footer-twitter.f2be3279917471e941877abf34066984.svg";
export { ForwardRef as ReactComponent };